import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";

// Context
import { AuthProvider } from "@/context/AuthContext";

// Public Pages
import HomePage from "@/pages/HomePage";
import PlaciCeramicePage from "@/pages/PlaciCeramicePage";
import ParchetPage from "@/pages/ParchetPage";
import ObiecteSanitarePage from "@/pages/ObiecteSanitarePage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ContactPage from "@/pages/ContactPage";

import RiflajePage from "@/pages/RiflajePage";
import BathroomConfiguratorPage from "@/pages/BathroomConfiguratorPage";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminPages from "@/pages/admin/AdminPages";
import AdminSettings from "@/pages/admin/AdminSettings";

// Components
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/placi-ceramice" element={<PlaciCeramicePage />} />
          <Route path="/placi-ceramice/:subcategory" element={<PlaciCeramicePage />} />
          <Route path="/parchet" element={<ParchetPage />} />
          <Route path="/parchet/:subcategory" element={<ParchetPage />} />
          <Route path="/obiecte-sanitare" element={<ObiecteSanitarePage />} />
          <Route path="/obiecte-sanitare/:subcategory" element={<ObiecteSanitarePage />} />
          <Route path="/riflaje" element={<RiflajePage />} />
          <Route path="/configurator-baie" element={<BathroomConfiguratorPage />} />
          <Route path="/produs/:id" element={<ProductDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/products" element={<ProtectedRoute><AdminProducts /></ProtectedRoute>} />
          <Route path="/admin/categories" element={<ProtectedRoute><AdminCategories /></ProtectedRoute>} />
          <Route path="/admin/pages" element={<ProtectedRoute><AdminPages /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
